module.exports = __webpack_public_path__ + "img/arrow-more.71df0e3d.svg";